"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["className", "defaultHoverStyling", "path", "viewBox", "style", "size", "children", "isInteractive"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var renderPaths = function renderPaths(path) {
  // if path is array, iterate through it to render multiple paths, otherwise, return single path
  if (Array.isArray(path)) {
    return path.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        d: item,
        key: index
      });
    });
  }
  return /*#__PURE__*/_react["default"].createElement("path", {
    d: path
  });
};

/**
 * Renders SVG icons from paths. Global icon paths are available for usage in
 * `lib/icons/[path-name]`. Select an icon path from the Icon Set above to copy its import statement.
 */
/* eslint-enable valid-jsdoc */
var Icon = function Icon(_ref) {
  var className = _ref.className,
    defaultHoverStyling = _ref.defaultHoverStyling,
    path = _ref.path,
    viewBox = _ref.viewBox,
    style = _ref.style,
    size = _ref.size,
    children = _ref.children,
    isInteractive = _ref.isInteractive,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!path && !children) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, otherProps, {
    "aria-hidden": "true",
    className: "valign-middle ".concat(className || ''),
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    style: _objectSpread({
      width: size,
      height: size,
      overflow: 'visible',
      fill: 'currentColor'
    }, style),
    viewBox: viewBox
  }), children || renderPaths(path), isInteractive && defaultHoverStyling && /*#__PURE__*/_react["default"].createElement("circle", {
    className: "sb-icon-hover",
    cx: "50%",
    cy: "50%",
    fill: "transparent",
    r: "75%"
  }));
};
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  /**
   * An SVG icon path string or array of path strings to be rendered.
   * If paths require individual styling, use `IconPath` children instead.
   */
  path: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * Prop indicating whether or not to use `sb-icon-hover` class
   */
  defaultHoverStyling: _propTypes["default"].bool,
  /**
   * A size for the rendered icon, including a unit (px, em, %, etc). All icons are rendered
   * as squares.
   */
  size: _propTypes["default"].string,
  style: _propTypes["default"].object,
  viewBox: _propTypes["default"].string.isRequired,
  /**
   * If the icon exists as a button or link, we need to provide feedback on hover and active
   * state for the user. When true, adds a circle with the class `sb-icon-hover`. Using the
   * component `IconButton` will handle this.
   */
  isInteractive: _propTypes["default"].bool
} : {};
Icon.defaultProps = {
  size: '24px',
  viewBox: '0 0 24 24'
};
Icon.displayName = 'Icon';
var _default = exports["default"] = Icon;